import React from "react";
import DropdownList from "react-widgets/DropdownList";
import "./Container.css";

const ArrInput = ({ setArrPort }) => {
  const updateArrPort = (arrPort) => {
    console.log(arrPort);
    setArrPort(arrPort);
  };

  return (
    <div className="arrinput">
      <DropdownList
        style={{ width: 450, fontSize: 15 }}
        onChange={updateArrPort}
        data={[
          "Gills Bay",
          "St. Margaret's Hope Ferry Terminal",
          "Oban",
          "Craignure",
        ]}
        placeholder="Select destination port"
      />
      <br />
    </div>
  );
};

export default ArrInput;
